import UserDispatcherUpdateRequest, {
  UserDispatcherUpdateRequestBody,
} from "./user-dispatcher-update.request";

const createBody = (
  data: UserDispatcherUpdateRequest,
): UserDispatcherUpdateRequestBody => {
  return {
    dispatchId: data.dispatchId,
    user: {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      mobilePrimary: data.mobilePrimary,
      mobilePrimaryPrefix: data.mobilePrimaryPrefix,
      mobileSecondary: data.mobileSecondary,
      mobileSecondaryPrefix: data.mobileSecondaryPrefix,
    },
  };
};

const userDispatcherUpdateRequestFactory = {
  createBody,
};

export default userDispatcherUpdateRequestFactory;
